(function taraRuntimeFixes() {
  const INGREDIENT_EMPTY_EN = 'No ingredients match your filters. Try adjusting your selection.';
  const INGREDIENT_EMPTY_ES = 'No hemos encontrado ingredientes con esos filtros. Prueba a ajustar la selección.';
  const CONTACT_TITLE_EN = 'Contact - Tara Spain';
  const CONTACT_TITLE_ES = 'Contacto - Tara Spain';

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function translateIngredientEmptyStates(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const candidates = scope.querySelectorAll('p, span, div');

    for (const element of candidates) {
      if (element.children.length > 0) continue;
      if (normalize(element.textContent) === INGREDIENT_EMPTY_EN) {
        element.textContent = INGREDIENT_EMPTY_ES;
      }
    }
  }

  function cleanupLegacyCollectionShell() {
    if (!document.body.classList.contains('template-collection')) return;

    document.querySelectorAll('.collection-editorial').forEach((node) => node.remove());
    document.querySelector('.collection-page-shell__eyebrow')?.remove();
    document.querySelectorAll('.collection-context').forEach((node) => {
      node.closest('.section, .section-wrapper, [id^="shopify-section"]')?.remove();
    });
    document.querySelectorAll('.collection-context__group-heading, .collection-context__cta').forEach((node) => {
      node.closest('.section, .section-wrapper, [id^="shopify-section"]')?.remove();
    });
  }

  function ensureCollectionHeading() {
    if (!document.body.classList.contains('template-collection')) return;
    if (document.querySelector('h1')) return;

    const intro = document.querySelector('.collection-intro');
    const introTitle = intro?.querySelector('.collection-intro__title');
    if (introTitle) {
      const heading = document.createElement('h1');
      heading.className = introTitle.className;
      heading.textContent = introTitle.textContent;
      introTitle.replaceWith(heading);
      return;
    }

    const wrapper = document.querySelector('.collection-wrapper');
    if (!wrapper) return;

    const title = normalize(document.title).replace(/\s+-\s+Tara Spain$/, '');
    if (!title) return;

    const header = document.createElement('header');
    header.className = 'collection-intro page-width-content';
    header.innerHTML = `<h1 class="collection-intro__title">${title}</h1>`;
    wrapper.insertAdjacentElement('beforebegin', header);
  }

  function localizeSpanishContactPage() {
    if (!document.body.className.includes('page-handle-contact')) return;
    if (!(document.documentElement.lang || '').includes('es')) return;

    if (normalize(document.title) === CONTACT_TITLE_EN) {
      document.title = CONTACT_TITLE_ES;
    }

    const heading = document.querySelector('main h1');
    if (heading && normalize(heading.textContent) === 'Contact') {
      heading.textContent = 'Contacto';
    }

    const submit = document.querySelector(
      'form[action*="/contact"] button[type="submit"], form[action*="/contact"] input[type="submit"]'
    );

    if (!submit) return;

    const label = submit.tagName === 'INPUT' ? submit.value : submit.textContent;
    if (normalize(label) === 'Submit') {
      if (submit.tagName === 'INPUT') {
        submit.value = 'Enviar';
      } else {
        submit.textContent = 'Enviar';
      }
    }
  }

  function refreshPage() {
    translateIngredientEmptyStates(document);
    cleanupLegacyCollectionShell();
    ensureCollectionHeading();
    localizeSpanishContactPage();
  }

  let scheduled = false;
  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      refreshPage();
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleRefresh);
  window.addEventListener('load', scheduleRefresh, { once: true });
  setTimeout(scheduleRefresh, 750);

  if (
    document.body.className.includes('page-handle-ingredients') ||
    document.body.classList.contains('template-collection') ||
    document.body.className.includes('page-handle-contact')
  ) {
    const observer = new MutationObserver(() => {
      scheduleRefresh();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
